// "Install MoneyHQ" on phones, until it is installed or dismissed: Android Chrome offers its own
// install prompt (captured early, lib/pwa.ts); iPhone browsers have none (Safari, and since iOS 16.4
// Chrome and the others too, add web apps from their Share menu), so the tip says where it is.
import { useEffect, useState } from 'react';
import { ShareIcon, XIcon } from 'lucide-react';
import { installPrompt, onInstallPrompt } from '@/lib/pwa';
import { Button } from '@/components/ui/button';

const KEY = 'mhq.installHint';
const standalone = () => matchMedia('(display-mode: standalone)').matches || (navigator as Navigator & { standalone?: boolean }).standalone === true;
const ios = () => /iphone|ipad|ipod/i.test(navigator.userAgent);
const iosChrome = () => /crios/i.test(navigator.userAgent);

export function InstallHint() {
  const [hidden, setHidden] = useState(() => {
    try { return standalone() || localStorage.getItem(KEY) === 'off'; } catch { return standalone(); }
  });
  const [prompt, setPrompt] = useState(installPrompt);
  useEffect(() => onInstallPrompt(setPrompt), []);
  const dismiss = () => { setHidden(true); try { localStorage.setItem(KEY, 'off'); } catch { /* this visit only */ } };
  if (hidden || !(prompt || ios())) return null;
  return (
    <div className="mx-auto mt-2 flex w-[min(1560px,100%-32px)] items-center gap-2 rounded-xl border bg-brand-soft/60 px-3 py-2 text-[13px] text-ink lg:hidden">
      <img src="/icons/icon-192.png" alt="" className="size-7 rounded-lg" />
      {prompt ? (
        <>
          <span className="flex-1">Install MoneyHQ on this phone: it opens like an app, full screen.</span>
          <Button size="sm" className="h-8 rounded-full" onClick={() => { void prompt.prompt(); void prompt.userChoice.finally(() => setPrompt(null)); }}>Install</Button>
        </>
      ) : (
        <span className="flex-1">Install MoneyHQ: tap <ShareIcon className="inline size-3.5 align-[-2px]" /> <b>Share</b>{iosChrome() ? ' (in the address bar)' : ''}, then <b>Add to Home Screen</b>.</span>
      )}
      <button type="button" aria-label="Dismiss" className="grid size-7 place-items-center rounded-full text-muted-foreground hover:bg-card" onClick={dismiss}><XIcon className="size-4" /></button>
    </div>
  );
}
